// Common
import { ComponentRef, Directive, input } from '@angular/core';

// Directives
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';

//Components
import { SectionContextMenuComponent } from '@modules/tasks/components/row-context-menu/row-context-menu.component';

// Types
import { Section } from '@modules/common/types/section';

@Directive({
  selector: '[appSectionContextMenu]',
  standalone: false,
})
export class SectionContextMenuDirective extends ContextMenuDirective {
  // Inputs
  public readonly appSectionContextMenu = input.required<Section>();
  public readonly canMoveUp = input(true);
  public readonly canMoveDown = input(true);

  registerComponent(): typeof SectionContextMenuComponent {
    return SectionContextMenuComponent;
  }

  registerInstance(componentRef: ComponentRef<SectionContextMenuComponent>): void {
    componentRef.instance.section = this.appSectionContextMenu();
    componentRef.instance.canMoveUp = this.canMoveUp();
    componentRef.instance.canMoveDown = this.canMoveDown();
  }
}
